/**
 * Ошибки, которые возникают на стороне фронта, а не приходят кодом от бэкенда.
 *
 * Строковый enum — чтобы ключи `overrides` не пересекались с числовыми `BackendErrorCode`.
 */
export enum ClientErrorCode {
  /** Запрос не дошёл до сервера: нет сети, сервер не ответил, CORS. */
  NETWORK = 'NETWORK',
}
